import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useTEMPLATE
 */

type State = {
    idsIndiceReajuste: number[]
    codigo?: number;

};

type Action = {
    setCodigo: (string: number | undefined) => void,
    setIdsIndiceReajuste: (list: number[]) => void,
    clearFilters: () => void
};

export const useIndiceReajusteListaFilters = create<State & Action>((set) => ({
    idsIndiceReajuste: [],
    codigo: undefined,
    setIdsIndiceReajuste: (list) => set({ idsIndiceReajuste: list }),
    setCodigo: (codigo) => set({ codigo }),
    clearFilters: () => set({
        codigo: undefined,
        idsIndiceReajuste: []
    }),
}));

export const initialIndiceReajusteFiltersValues: State = {
    idsIndiceReajuste: []

}